import { Chip } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.AppProducts;

export const ActiveChip = () => {
  const { t } = useResource();

  return (
    <Chip
      component="span"
      label={t(RESOURCES.ProductAccordion.Active)}
      variant="outlined"
      size="small"
      color="primary"
    />
  );
};
